export const OBJECT_DETECTION_OPTIONS = [
  // People
  { value: 'Person', text: 'Person' },
  { value: 'Man', text: 'Man' },
  { value: 'Woman', text: 'Woman' },
  { value: 'Boy', text: 'Boy' },
  { value: 'Girl', text: 'Girl' },
  { value: 'Adult', text: 'Adult' },
  { value: 'Child', text: 'Child' },
  { value: 'Baby', text: 'Baby' },
  { value: 'Teen', text: 'Teen' },
  { value: 'Senior Citizen', text: 'Senior Citizen' },
  { value: 'Student', text: 'Student' },
  { value: 'Teacher', text: 'Teacher' },
  { value: 'Doctor', text: 'Doctor' },
  { value: 'Police Officer', text: 'Police Officer' },
  { value: 'Fireman', text: 'Fireman' },
  { value: 'Soldier', text: 'Soldier' },
  // Animals
  { value: 'Animal', text: 'Animal' },
  { value: 'Dog', text: 'Dog' },
  { value: 'Cat', text: 'Cat' },
  { value: 'Bird', text: 'Bird' },
  { value: 'Horse', text: 'Horse' },
  { value: 'Cow', text: 'Cow' },
  { value: 'Sheep', text: 'Sheep' },
  { value: 'Pig', text: 'Pig' },
  { value: 'Chicken', text: 'Chicken' },
  { value: 'Duck', text: 'Duck' },
  // Vehicles
  { value: 'Vehicle', text: 'Vehicle' },
  { value: 'Car', text: 'Car' },
  { value: 'Truck', text: 'Truck' },
  { value: 'Motorcycle', text: 'Motorcycle' },
  { value: 'Bicycle', text: 'Bicycle' },
  { value: 'Bus', text: 'Bus' },
  { value: 'Train', text: 'Train' },
  { value: 'Boat', text: 'Boat' },
  { value: 'Airplane', text: 'Airplane' },
  { value: 'Ambulance', text: 'Ambulance' },
  { value: 'Fire Truck', text: 'Fire Truck' },
  { value: 'Police Car', text: 'Police Car' },
  { value: 'Taxi', text: 'Taxi' },
  { value: 'Van', text: 'Van' },
  { value: 'SUV', text: 'SUV' },
  { value: 'Race Car', text: 'Race Car' },
  { value: 'Tractor', text: 'Tractor' },
  { value: 'Helicopter', text: 'Helicopter' },
  { value: 'Cruise Ship', text: 'Cruise Ship' },
  { value: 'Submarine', text: 'Submarine' }
] 